import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Card,
    Box,
    Tabs,
    Tab,
    CardContent,
    Skeleton
} from '@mui/material';
import {
    History as HistoryIcon,
    Hub as NetworkIcon,
    Analytics as AnalyticsIcon
} from '@mui/icons-material';
import UserTransactionsTab from './UserTransactionsTab.component';
import UserNetworkTab from './UserNetworkTab.component';
import UserAnalyticsTab from './UserAnalyticsTab.component';

const UserTabsContainer = ({
    tabValue,
    onTabChange,
    userId,
    transactions,
    loading,
    hasMore,
    loadingMore,
    onLoadMoreTransactions
}) => {
    const { t } = useTranslation();

    return (
        <Card>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                {loading ? (
                    <Box sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', gap: 3 }}>
                            <Skeleton variant="text" width={150} height={32} />
                            <Skeleton variant="text" width={180} height={32} />
                            <Skeleton variant="text" width={160} height={32} />
                        </Box>
                    </Box>
                ) : (
                    <Tabs value={tabValue} onChange={onTabChange}>
                        <Tab
                            label={t('user.recentTransactions')}
                            icon={<HistoryIcon />}
                            iconPosition="start"
                        />
                        <Tab
                            label={t('user.networkConnections')}
                            icon={<NetworkIcon />}
                            iconPosition="start"
                        />
                        <Tab
                            label={t('user.activityAnalytics')}
                            icon={<AnalyticsIcon />}
                            iconPosition="start"
                        />
                    </Tabs>
                )}
            </Box>

            <CardContent>
                {/* Transactions Tab */}
                {tabValue === 0 && (
                    <UserTransactionsTab
                        transactions={transactions}
                        loading={loading}
                        hasMore={hasMore}
                        loadingMore={loadingMore}
                        onLoadMore={onLoadMoreTransactions}
                    />
                )}

                {/* Network Tab */}
                {tabValue === 1 && (
                    <UserNetworkTab userId={userId} />
                )}

                {/* Analytics Tab */}
                {tabValue === 2 && (
                    <UserAnalyticsTab
                        transactions={transactions}
                        loading={loading}
                    />
                )}
            </CardContent>
        </Card>
    );
};

export default UserTabsContainer;
